import { default as _products } from './product.json';
import { default as _merchant } from './merchant.json';


export default {
    ..._products,
    ..._merchant,
}